import React from 'react'

import Container from 'components/Container'
import Heading from 'components/Heading'
import Meta from 'components/Meta'
import PasswordChangeForm from 'components/PasswordChangeForm'

export default function Account() {
  const title = 'Account'

  return (
    <div className="Account">
      <Meta title={title} />
      <Container>
        <Heading level="1">Account</Heading>
        <p>
          Enter a new password
        </p>
        <PasswordChangeForm />
      </Container>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/views/Account/Account.js